import React from 'react';
import "../styles//Joining.css";
import Swal from 'sweetalert2';

const Joining = () => {
  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    formData.append("access_key", "3992e56e-0d35-42b6-94bd-c39777fbeb89");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Success!",
        text: "Message Sent Successfully",
        icon: "success"
      });
      form.reset();
    }
  };

  return (
    <div className="forms">
      <form className='contactform' onSubmit={onSubmit}>
        <div className='inputs'>
          <input type="text" name='name' placeholder='Enter Your name' required />
        </div>

        <div className='inputs'>
          <input type="email" name='email' placeholder='Enter Your mail' required />
        </div>

        <div className='inputs'>
          <input
            type="text"
            name="contact"
            placeholder="Enter Your Contact"
            pattern="^[0-9]{10}$"
            title="Contact number must be exactly 10 digits and contain only numbers."
            required
          />
        </div>

        <div className='inputs'>
          <textarea placeholder='Message Box' name='message' required></textarea>
        </div>
        <button className='but'>Submit</button>
      </form>
    </div>
  )
}

export default Joining;
